import { Router, Route, Switch } from "react-router-dom";
import history from "../../utils/history";
import LandingPage from "../../modules/Geral/pages/LandingPage";
import "./AppContainer.css";
import ErrorPage from "../../modules/Geral/pages/ErrorPage";
import {
  ERROR_PAGE_ROUTE,
  LANDING_PAGE_ROUTE,
  PRIVACY_POLICY_ROUTE,
  redirectToLandingPage,
  TERMS_OF_SERVICE_ROUTE,
} from "./RoutesRedirects";
import TermsOfService from "../../modules/Geral/pages/TermsOfService";
import PrivacyPolicy from "../../modules/Geral/pages/PrivacyPolicy";
import "bootstrap/dist/css/bootstrap.min.css";
import CookiesInfo from "../../components/cookies/CookiesInfo";
import Flash from "../../components/flash/Flash";
import ScrollToTop from "./ScrollToTop";
import { useEffect } from "react";
import { useLanguage } from "../../modules/Geral/hooks/useLanguage";
import ReactGA from "react-ga";
import {
  canTrackAnalytics,
  removeAnalyticsCookies,
} from "../../utils/helpers/cookiesHelpers/cookiesHelper";

//initializes google analytics
if (canTrackAnalytics()) ReactGA.initialize("UA-35311532-3");

const MAINTENANCE = false;

/**
 * Functional Component: App
 * Contains all the app routes
 * @returns {Component}
 */
const App = () => {
  //tracks all routes changes with google analytics
  useEffect(() => {
    if (canTrackAnalytics())
      ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    if (!canTrackAnalytics()) removeAnalyticsCookies();
  }, []);

  useLanguage();

  return (
    <Router history={history}>
      <ScrollToTop />
      <Flash />
      {MAINTENANCE ? <Maintenance /> : <Violet />}
    </Router>
  );
};

const Violet = () => {
  return (
    <Switch>
      <Route path={LANDING_PAGE_ROUTE} exact component={LandingPage} />
      <Route path={TERMS_OF_SERVICE_ROUTE} component={TermsOfService} />
      <Route path={PRIVACY_POLICY_ROUTE} component={PrivacyPolicy} />
      <Route
        path={ERROR_PAGE_ROUTE}
        render={() => (
          <ErrorPage type="internal" buttonFunction={redirectToLandingPage} />
        )}
      />
      <Route
        render={() => (
          <ErrorPage type="not-found" buttonFunction={redirectToLandingPage} />
        )}
      />
    </Switch>
  );
};

const Maintenance = () => {
  return (
    <Switch>
      <Route render={() => <ErrorPage type="maintenance" />} />
    </Switch>
  );
};

export default App;
